import React from "react";
import HeroSection from "../../containers/HeroSection";
import Plan from "../../containers/Plan";
import HomepageFeatures from "../HomePageFeatures";
import BusinessPlanCard from "./businessPlanCard";
import FAQ from "./faq";
const Home = () => {
  return (
    <>
      <HeroSection />
      <HomepageFeatures/>
      <Plan />
      <BusinessPlanCard />
      <FAQ />
    </>
  );
};

export default Home;
